import { render, staticRenderFns } from "./showdoc.vue?vue&type=template&id=75a5ccd9&scoped=true"
import script from "./showdoc.vue?vue&type=script&lang=js"
export * from "./showdoc.vue?vue&type=script&lang=js"
import style0 from "./showdoc.vue?vue&type=style&index=0&id=75a5ccd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a5ccd9",
  null
  
)

export default component.exports